import { ListItem } from './../../../shared/list-confirmation/model/list-item';
import { TransactionDetail } from './transaction-detail';

export class Transaction {
	code: number;
	date: string;
	hour: string;
	value: number;
	favored: string;
	requester: string;
	situation: string;
	situationLabel: string;
	typeTransaction: string;
	typeTransactionLabel: string;
	details: Array<ListItem> = [];
	status = 'Pendente';
	statusCode = 4;
	debitDate: string;
	loading: boolean;
	reason: string;
	useNewLimit: boolean;
	Authorizers: Authorizers[];

	constructor() {}
}

export class Authorizers{
	NomeAutorizador: string;
	DataHoraSituacao: Date;
	SituacaoAutorizacao: ESituacaoTransferenciaAutorizacao;
}

export enum ESituacaoTransferenciaAutorizacao{
	none = "None",
	aprovado = "TRANSFERENCIA_AUTORIZADA",
	reprovado = "TRANSFERENCIA_REPROVADA"
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transaction-history/models/transaction.ts